module.exports = __webpack_public_path__ + "static/colgadas-012.thumb-7581acb9ea42737b3c3272920eaefc1d.jpg";